import { Component, OnInit } from '@angular/core';
import {SettingsProviderService} from '../../../common/settings-provider.service';

@Component({
  selector: 'app-eca-app-version',
  templateUrl: './eca-app-version.component.html',
  styleUrls: ['./eca-app-version.component.scss']
})
export class EcaAppVersionComponent implements OnInit {
  appVersion = '0.0.0';
  settingsProviderService  = new SettingsProviderService('ecaApi');
  constructor() {

  }

  ngOnInit(): void {
    this.appVersion = this.settingsProviderService?.appVersion;
  }

}
